<template>
  <gj-table
      v-bind="$attrs"
      v-on="$listeners"
      name="keywordRank"
      :columns="columns"
      sortable="custom">
    <template v-slot:asin="{row}">
      <gj-link :href="row.asinUrl" target="_blank">{{row.asin}}</gj-link>
    </template>
    <template v-slot:keyword="{row}">
      <gj-tooltip :text-line="2" :content="row.keyword">
        <gj-link :href="row.keywordUrl" target="_blank">{{row.keyword}}</gj-link>
      </gj-tooltip>
    </template>
    <template v-slot:header:natureRank>
      自然排名
      <gj-help class="gj-help"> {{ natureLastUpdateTime || "-" }} </gj-help>
      <div>(页码/页内排名)</div>
    </template>
    <template v-slot:header:adsRank>
      广告排名
      <gj-help class="gj-help"> {{ adsLastUpdateTime || "-" }} </gj-help>
      <gj-tooltip>
        <i class="el-icon-warning"></i>
        <template #content>
          <div>
              <div style="text-align: justify;">1、广告排名和自然排名互相不包括：比如某广告处于页面第5个位置，前面4个均为自然结果，则广告排名显示为1，而非5。</div>
              <div style="text-align: justify;">2、排名更新时间为数据更新时间，不等同于抓取时间。</div>
              <div style="text-align: justify; padding-bottom: 3px">3、当出现无排名情况时，请先进行如下检查：</div>
              <div style="text-align: justify;"> - 如是父ASIN，检查所属店铺已正常开启授权</div>
              <div style="text-align: justify;"> - 检查ASIN是否填写正确，并且“父/子”类别选择正确</div>
              <div style="text-align: justify;"> - 广告出现在前三页时才能正常获取到排名</div>
              <div style="text-align: justify;"> - 添加ASIN和关键词后最长需要24小时后才能查看到排名</div>
          </div>
        </template>
      </gj-tooltip>
      <div>(页码/页内排名)</div>
    </template>
    <template v-slot:natureRank="{row}">
      <template v-if="row.naturePageRank === 0">
        前三页无排名
      </template>
      <template v-else-if="row.naturePageRank > 0">
        {{row.naturePageNum}}/{{row.naturePageRank}}
      </template>
      <template v-else>
       -
      </template>
    </template>
    <template v-slot:adsRank="{row}">
      <template v-if="row.adsPageRank === 0">
        前三页无排名
      </template>
      <template v-else-if="row.adsPageRank > 0">
        {{row.adsPageNum}}/{{row.adsPageRank}}
        <template v-if="row.trend === KeywordRankEnum.trend.UP">
          <gj-icon class="el-icon-top up-icon"></gj-icon>
        </template>
        <template v-else-if="row.trend === KeywordRankEnum.trend.DOWN">
          <gj-icon class="el-icon-bottom down-icon"></gj-icon>
        </template>
        <template v-else-if="row.trend === KeywordRankEnum.trend.NO">
          <gj-icon class="el-icon-right no-icon"></gj-icon>
        </template>
      </template>
      <template v-else>
        -
      </template>
    </template>
    <!-- <template v-slot:adsPageRank="{row}">
      <div>广告页码：{{row.adsPageNum ? row.adsPageNum : '-'}}</div>
      <div>页码排名：{{row.adsPageRank ? row.adsPageRank : '-'}}</div>
    </template> -->
    <template v-slot:ranks="{row}">
      <app-keyword-rank-mini-trend
          :data="row.ranks || []"
      ></app-keyword-rank-mini-trend>
    </template>
    <template v-slot:trend="{row}">
      <gj-button
          type="text"
          style="font-size: 21px;"
          @click="analysis(row)">
        <gj-icon iconfont="iconshuju1"></gj-icon>
      </gj-button>
    </template>
  </gj-table>
</template>

<script>
  import {KeywordRankEnum} from "@/views/modules/common/ad/rank/keyword-rank/enum";
  import AppKeywordRankMiniTrend from "@/views/modules/common/ad/rank/keyword-rank/charts/keyword-rank-mini-trend";
  import AppKeywordRankTrendModal from "@/views/modules/common/ad/rank/keyword-rank/modal/trend/keyword-rank-trend-modal";
  import {isMeaningful} from "@/utils/common";
  import { keywordRank } from "@/api/ad.js"

  export default {
    name: "app-ad-keyword-rank-table",
    components: {AppKeywordRankMiniTrend},
    props: {
      showCountry: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        KeywordRankEnum,
        tableData: [],
        columns: [],
        natureLastUpdateTime: null, // 自然排名更新时间
        adsLastUpdateTime: null, // 广告排名更新时间
      }
    },
    created() {
      this.columns = [
        this.showCountry ? {id: 'country', header: '国家', field: 'countryCode', width: '80px'} : null,
        {id: 'asin', header: 'ASIN', field: 'slot:asin', width: '150px'},
        {id: 'keyword', header: '关键词', field: 'slot:keyword', width: '200px'},
        {id: 'natureRank', header: 'slot:natureRank', field: 'slot:natureRank', minWidth: '80px', align: 'center'},
        {id: 'adsRank', header: 'slot:adsRank', field: 'slot:adsRank', minWidth: '80px', align: 'center'},
        {id: 'ranks', header: '排名趋势', field: 'slot:ranks', minWidth: '300px'},
        {id: 'trend', header: '趋势', field: 'slot:trend', width: '80px'},
      ].filter(item => isMeaningful(item));
      this.lastUpdateTime()
    },
    methods: {
      // 获取关键词排名更新时间
      async lastUpdateTime() {
        let { data } = await keywordRank.lastUpdateTime()
        this.natureLastUpdateTime = data?.natureLastUpdateTime || null
        this.adsLastUpdateTime = data?.adsLastUpdateTime || null
      },
      analysis(item) {
        this.$gjCreate(AppKeywordRankTrendModal, {
          props: {
            keyword: item
          }
        });
      }
    }
  }
</script>

<style scoped>
  .up-icon,
  .down-icon,
  .no-icon {
    font-weight: bold;
  }
  .up-icon {
    color: green;
  }
  .down-icon {
    color: red;
  }
  .gj-help {
    cursor: pointer;
  }
  .el-icon-warning {
    font-size: 14px;
    color: #666;
    padding-left: 3px;
    cursor: pointer;
    transform: translateY(1px);
  }
</style>
